import { trackEvent } from "../../../Actions/Utils";
import { textColor, borderColorChips } from "../../../NewConstants/OptionConstants";
const DefaultChips = ({
    option,
    selectedLanguage,
    send = () => {},
    textSize,
    disabled,
    index,
    selectedChipIndex, 
    isLoading,
    onChipClick,
    setChipsClicked
  }) => {
    function saveResponse(input, image) {
      send(index, input, false, image);
    }
  
    return (
      <div
        className={`flex items-center justify-start shadow-[0_0_4px_0_#00000040] rounded-xl border border-solid gap-3 bg-[var(--neutral-white)] min-h-[3.938rem] px-2 ${isLoading ? 'pointer-events-none' : ''}`}
          onClick={() => {
              setChipsClicked(true);
              onChipClick(option.value[selectedLanguage]);
              saveResponse(option.value[selectedLanguage], option.img);
              trackEvent("default_chip_clicked", "Click", "Number of times users click on default chips menu");
            }}
            style={{
              fontSize: `${textSize}rem`,
              color: textColor[option.id - 1],
              border: `1px solid ${borderColorChips[option.id - 1]}`
            }}
      >
        {option.img && <img
            src={option.img}
            alt={option.value[selectedLanguage]}
            className="h-100 w-100 mt-2"
          />}
        <div style={{wordBreak: 'break-word', hyphens: 'auto'}} >
          {option.value[selectedLanguage]}
        </div>
      </div>
    );
  };
  
  export default DefaultChips;
  